export default "__VITE_ASSET__6463294a__"